enum TagIds {
  AccidentFree = 21,
  EvTaxCreditMayBeEligible = 116,
  GreatDeals = 104,
  LowMileage = 119,
  LowMilesPerYear = 120,
  NoReportedAccidents = 21,
  PriceDrop = 103,
  RecentlyAdded = 121,
  SingleOwner = 20
}

export default TagIds;
